/* global ol */

var angular = require('angular');

module.exports.coordinate = function(location) {
  var coordinate = [location.longitude, location.latitude];

  return ol.proj.transform(coordinate, 'EPSG:4326', 'EPSG:3857');
};

module.exports.point = function(location) {
  return new ol.geom.Point(module.exports.coordinate(location));
};

module.exports.equalCoordinates = function(coordinate1, coordinate2) {
  return angular.equals(coordinate1 || null, coordinate2 || null);
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/util.js
 ** module id = 14
 ** module chunks = 1
 **/